import { useTranslation } from "react-i18next";
import { IContractDetailsResponseData } from "../../../../setup/api/services/contract/models";
import PartyTable from "../../create/partyTable";
import { EPARTY_STATUS } from "../../../../enums";
import styles from "./styles.module.scss";

interface MainDetailsProps {
  milestone: IContractDetailsResponseData | undefined;
}

const MainDetails = ({ milestone }: MainDetailsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.partyContainer}>
        <h2>{t("lbl_payees")}</h2>

        <PartyTable
          detailsPage
          rows={(milestone?.partiesProfiles?.CUSTOMER || [])?.map((party) => {
            const currentParty = milestone?.parties?.find(
              (partyObject) => partyObject?.phoneNumber === party?.phoneNumber
            );
            return {
              id: party?.id?.toString() || "",
              name: party?.profile?.fullName || "",
              phoneNumber: party?.phoneNumber || "",
              amount: currentParty?.amount || 0,
              status: currentParty?.status,
              type: "customer",
              fee: 0,
              total: +(currentParty?.fee || 0) + +(currentParty?.amount || 0),
              image: party?.profile?.photoUrl || "",
            };
          })}
          columns={{
            showActions: false,
            showStatus: true,
            showRole: false,
            showFee: false,
            showTotal: false,
          }}
          getIndexByRow={(row) =>
            (milestone?.parties || [])?.findIndex(
              (p) => p?.id?.toString() === row?.id
            )
          }
        />
      </div>

      <div className={styles.partyContainer}>
        <h2>{t("lbl_receivers")}</h2>

        <PartyTable
          detailsPage
          rows={(milestone?.partiesProfiles?.PROVIDER || [])?.map((party) => {
            const currentParty = milestone?.parties?.find(
              (partyObject) => partyObject?.phoneNumber === party?.phoneNumber
            );
            return {
              id: party?.id?.toString() || "",
              name: party?.profile?.fullName || "",
              phoneNumber: party?.phoneNumber || "",
              amount: currentParty?.amount || 0,
              status:
                milestone?.cashOutAmountList?.find(
                  (item) => item?.userIdentification === currentParty?.userId
                )?.settlementAmountStatus === EPARTY_STATUS.AVAILABLE_BALANCE
                  ? EPARTY_STATUS.AVAILABLE_BALANCE
                  : currentParty?.status,
              type: "provider",
              fee: 0,
              total: +(currentParty?.fee || 0) + +(currentParty?.amount || 0),
              image: party?.profile?.photoUrl || "",
            };
          })}
          columns={{
            showActions: false,
            showStatus: true,
            showRole: false,
            showFee: false,
            showTotal: false,
          }}
          getIndexByRow={(row) =>
            (milestone?.parties || [])?.findIndex(
              (p) => p?.id?.toString() === row?.id
            )
          }
        />
      </div>

      <div className={styles.partyContainer}>
        <h2>{t("lbl_brokers")}</h2>

        <PartyTable
          detailsPage
          rows={(milestone?.partiesProfiles?.BROKER || [])?.map((party) => {
            const currentParty = milestone?.parties?.find(
              (partyObject) => partyObject?.phoneNumber === party?.phoneNumber
            );
            return {
              id: party?.id?.toString() || "",
              name: party?.profile?.fullName || "",
              phoneNumber: party?.phoneNumber || "",
              amount: currentParty?.amount || 0,
              status:
                milestone?.cashOutAmountList?.find(
                  (item) => item?.userIdentification === currentParty?.userId
                )?.settlementAmountStatus === EPARTY_STATUS.AVAILABLE_BALANCE
                  ? EPARTY_STATUS.AVAILABLE_BALANCE
                  : currentParty?.status,
              type: "provider",
              fee: 0,
              total: +(currentParty?.fee || 0) + +(currentParty?.amount || 0),
              image: party?.profile?.photoUrl || "",
            };
          })}
          columns={{
            showActions: false,
            showStatus: true,
            showRole: false,
            showFee: false,
            showTotal: false,
          }}
          getIndexByRow={(row) =>
            (milestone?.parties || [])?.findIndex(
              (p) => p?.id?.toString() === row?.id
            )
          }
        />
      </div>
    </>
  );
};

export default MainDetails;
